/**
 * ResetPasswordConfirmation.jsx
 * Created by michaelbray on 2/14/18.
 * Updated by Destin Frasier on 1/11/19.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FlexCol, FlexRow } from '../../../sharedComponents/FlexGrid';
import Button from '../../../sharedComponents/Button';
import Heading from '../../../sharedComponents/Heading';

const propTypes = {
    email: PropTypes.string,
    sendResetPasswordEmail: PropTypes.func,
    disableResetLinkBtn: PropTypes.bool
};

export default class ResetPasswordConfirmation extends React.Component {
    constructor(props) {
        super(props);
        this.resendConfirmationEmail = this.resendConfirmationEmail.bind(this);
    }

    componentDidMount() {
        this.header.focus();
    }

    resendConfirmationEmail(e) {
        e.preventDefault();
        this.props.sendResetPasswordEmail();
    }

    render() {
        return (
            <FlexRow justifyContent="center">
                <FlexCol sm={6} md={5} xl={4} className="rec-acct-modal-reset-confirmation-body">
                    <div ref={(header) => this.header = header} tabIndex="-1" className="rec-hide-focus">
                        <Heading
                            headingLevel={1}
                            appearance="display"
                            className="rec-acct-modal-title"
                            id="resetPasswordModalHeading">
                            Check Your Email
                        </Heading>
                    </div>
                    <p>
                        An email has been sent to <strong>{this.props.email}</strong>. Once you confirm your
                        email, you will be able to reset the password for your account.
                    </p>
                    <Button
                        shouldFitContainer
                        onClick={(e) => this.resendConfirmationEmail(e)}
                        size="lg"
                        title="Resend Email"
                        aria-label="Resend Email"
                        isDisabled={this.props.disableResetLinkBtn}>
                        Resend Email
                    </Button>
                </FlexCol>
            </FlexRow>
        );
    }
}

ResetPasswordConfirmation.propTypes = propTypes;
